module.exports = __webpack_public_path__ + "media/src/images/arrow-179309a42baf5f8c9050aba8b1fa9b8f.svg";